import { NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SeAlertModule, SeButtonModule, SePersonaAvatarModule, SeProgressBarModule, SeSpinnerModule } from '@se-ui-components'

import { AlertComponent } from './alert.component'
import { AutoFormatDirective } from './auto-format.directive'
import { DropdownDatePickerComponent } from './dropdown-date-picker.component'
import { OAuthCallbackComponent } from './oauth-callback.component'
import { PersonaPickerComponent } from './persona-picker.component'
import { PostalCodeValidatorDirective } from './postal-code-validator.directive'
import { ProgressBarComponent } from './progress-bar.component'
import { SpinnerComponent } from './spinner.component'
import { TelPipe } from 'app/shared/pipes/tel.pipe'
import { AutoFormatService } from 'app/services/auto-format.service'
import { GeographicService } from 'app/services/geographic.service'
import { MissingInformationComponent } from './missing-information/missing-information.component'

@NgModule({
  declarations: [
    AlertComponent,
    AutoFormatDirective,
    DropdownDatePickerComponent,
    MissingInformationComponent,
    OAuthCallbackComponent,
    PersonaPickerComponent,
    PostalCodeValidatorDirective,
    ProgressBarComponent,
    SpinnerComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SeAlertModule,
    SeButtonModule,
    SePersonaAvatarModule,
    SeProgressBarModule,
    SeSpinnerModule
  ],
  exports: [
    AlertComponent,
    AutoFormatDirective,
    DropdownDatePickerComponent,
    MissingInformationComponent,
    OAuthCallbackComponent,
    PersonaPickerComponent,
    PostalCodeValidatorDirective,
    ProgressBarComponent,
    SpinnerComponent
  ],
  providers: [
    DatePipe,
    TelPipe,
    AutoFormatService,
    GeographicService
  ]
})
export class ComponentsModule { }
